import VueRouter from "vue-router";
import { createProgressStartGuard } from "./NProgressGuard";
export function onChangeRouterStart(router: VueRouter): void {
  createProgressStartGuard(router);
  router.beforeEach(async (to, from, next) => {
    if (to.matched.length !== 0) {
      next();
      return true;
    } else {
      next({ path: "/404" });
    }
  });
}
